// extracted by mini-css-extract-plugin
module.exports = {"package-list":"VerticalFeaturePackageList--package-list--1FW8I","packageList":"VerticalFeaturePackageList--package-list--1FW8I","item":"VerticalFeaturePackageList--item--3CNwa"};